import { memo } from 'react';
import {
  Stack, Typography, Button as MuiButton, Link as MuiLink,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { SideDoorIcon } from '@client/images/logos/SideDoorIcon';
import { Center } from '../common/Center';

const useStyles = makeStyles({ name: 'SomethingWentWrong' })({
  root: {
    height: '100vh',
  },
  icon: {
    fontSize: 40,
    margin: '0 auto !important',
  },
});

export const SomethingWentWrong = memo(() => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Center>
        <Stack spacing={3}>
          <SideDoorIcon className={classes.icon} />

          <Typography variant="subtitle1">
            Sorry, something went wrong.
          </Typography>

          <Typography>
            Refresh the page to try again or
            {' '}

            <MuiLink
              id="sda-error-email-link"
              href={`mailto:${process.env.SUPPORT_EMAIL}`}
              variant="body1"
            >
              contact us
            </MuiLink>

            {' '}
            if the issue persists.
          </Typography>

          <div>
            <MuiButton
              variant="outlined"
              color="info"
              onClick={() => window.location.reload()}
              id="sda-error-refresh-button"
              size="large"
            >
              Refresh Page
            </MuiButton>
          </div>
        </Stack>
      </Center>
    </div>
  );
});
